import { styled } from '@mui/material/styles';
import { PopupButton } from '../../../styles/buttonStyles';

export const ButtonStyled = styled(PopupButton)(({ theme }) => ({
  width: '150px',
  [theme.breakpoints.down('sm')]: {
    width: '100px',
  },
}));
